import { ApiService } from "./ApiService"

export class TransactionCategoryService {

    static uri = '/transaction-category';

    static get({params}) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers:{
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}